// @ts-nocheck
import React, { useState, useEffect } from 'react'
import * as S from './styled'
import { Block } from '@xprog/prensa'
import IconButton from "components/Buttons/IconButton.index";
import { useIcon } from "hooks/useIcon";
import SelectInput from './Input';
import ContentInput from './Input/content.json'
import InputNewsletter from 'components/Input/InputNewsletter.index';
import { NewsletterButton } from 'components/Buttons/NewsletterButton.index';
import axios from 'axios'
import queryString from 'query-string';
import { toast } from 'react-toastify'
import { fetchApi } from 'providers/actions/util'
import { getStoreId } from 'utils/getStoreId';

const Newsletter: React.FC<any> = () => {
  const [input, setInput] = useState({ name: "", email: "" });
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [shouldClear, setShouldClear] = useState(false);
  const [rdStationList, setRdStationList] = useState();

  const iconNewsletter = useIcon("IcNewsletter");
  const iconMoreSubjects = useIcon("icMoreSubjects");

  const storeId = getStoreId();

  useEffect(() => {
    loadRdStationList();
  }, []);

  useEffect(() => {
    if (shouldClear) {
      setShouldClear(false);
    }
  }, [shouldClear]);

  const loadRdStationList = async () => {
    try {
      const url = `/siteApi/rdStationList/cf_sobre_o_que_voce_gosta_de_ler_no_jornal?storeId=${storeId}`;
  
      const rdStationList = await axios.get(url);
  
      setRdStationList(rdStationList.data ? rdStationList.data : ContentInput);
    } catch (error) {
      console.error("Erro ao carregar rdStationList:", error);
    }
  };
  

  const handleInputChange = (fieldName: string, value: string) => {
    setInput(prevState => ({
      ...prevState,
      [fieldName]: value
    }));
  }

  const handleSubmit = async () => {
    if (!input.email || !input.name) {
      toast.warning('Preencha todos os campos antes de enviar.');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(input.email)) {
      toast.warning('Insira um email válido.');
      return;
    }

    const data = {
      email: input.email,
      conversionIdentifier: "newsletter-geral-completo",
      name: input.name,
      customField: JSON.stringify(selectedItems.map(item => item[0])),
      storeId: storeId
    };

    const queryStringData = queryString.stringify(data);

    try {
      const response = await axios.get(`/send-to-rdstation/api/send-to-rdstation?${queryStringData}`, {
        params: { storeId }
      })
      toast.success('Formulário enviado com sucesso');
      setInput({ name: "", email: "" });
      setShouldClear(true);
    } catch (err) {
      toast.error('Erro no envio do formulário');
      console.log(err);
    }
  };

  return (
    <S.ContainerNewsletter>
      <S.ContainerTitle
        customCss={{
          align: ['column', 'left', 'middle'],
          '@lg': {
            align: ['row', 'left', 'middle'],
            width: 'calc(100% - 48px)',
          }
        }}>
        <Block
          css={{
            align: ['row', 'left', 'middle'],
            mb: '$2',
            '@lg': {
              borderRight: '1px solid #E6E6E6',
              mr: '$3'
            }
          }}>
          <Block css={{ mr: '$3' }}>
            <IconButton icon={iconNewsletter} />
          </Block>
          <S.Title customCss={{ mr: '$2' }}>
            Newsletter
          </S.Title>
        </Block>
        <S.Subtitle customCss={{ mb: '$4' }}>
          Escolha seus assuntos favoritos e receba em primeira mão as notícias do dia.
        </S.Subtitle>
      </S.ContainerTitle>
      <S.ContainerSubject>
        <SelectInput content={rdStationList} selectedItems={selectedItems} setSelectedItems={setSelectedItems} clear={shouldClear} />
      </S.ContainerSubject>
      <S.ContainerInputs>
        <Block css={{ mr: '10px', width: '100%' }}>
          <InputNewsletter
            placeholder='Seu nome'
            value={input.name}
            onChange={e => handleInputChange('name', e.target.value)} />
        </Block>
        <Block css={{ mr: '10px', width: '100%' }}>
          <InputNewsletter
            placeholder='Insira seu email'
            value={input.email}
            onChange={e => handleInputChange('email', e.target.value)} />
        </Block>
        <S.ContainerButton>
          <NewsletterButton onClick={handleSubmit} />
        </S.ContainerButton>
      </S.ContainerInputs>
    </S.ContainerNewsletter>
  )
}

export default Newsletter
